const baseKey = '/v1/trader/requisitfarms'

export const farmsAPI = {
  baseKey,
  create: `${baseKey}/create`,
  getFarm: (id: string) => `${baseKey}/${id}`,
  getFarmRequisite: () => `${baseKey}/detail`,
  deleteFarm: (id: string) => `${baseKey}/${id}`,
  disableFarm: (id: string) => `${baseKey}/disable/${id}`,
  enableFarm: (id: string) => `${baseKey}/enable/${id}`,
  getMany: (skip: string, take: string) => `${baseKey}/getmany/${skip}/${take}`,
  updateFarm: `${baseKey}/update`,
  dailystat: (requisitFarmId: string, dateOnlyUtc: string) =>
    `${baseKey}/dailystat/${requisitFarmId}/${dateOnlyUtc}`,
  monthlystat: (requisitFarmId: string, dateOnlyUtc: string) =>
    `${baseKey}/monthlystat/${requisitFarmId}/${dateOnlyUtc}`,
}
